import { Link } from "react-router-dom";
import { CompaireLockup } from "@/components/brand";
import MarketingFooter from "@/components/marketing/MarketingFooter";

type FooterLink = {
  label: string;
  href: string;
  external?: boolean;
};

const productLinks: FooterLink[] = [
  { label: "For Agents", href: "/agents" },
  { label: "For Teams & Brokerages", href: "/teams-brokerages" },
  { label: "Pricing", href: "/pricing" },
  { label: "How It Works", href: "/agents" },
];

const companyLinks: FooterLink[] = [
  { label: "About", href: "/about" },
  { label: "Press", href: "/press" },
  { label: "Contact", href: "mailto:hello@compaire.co" },
];

const legalLinks: FooterLink[] = [
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Terms of Service", href: "/terms" },
  { label: "Anonymity Promise", href: "#" },
  { label: "Data Handling", href: "#" },
];

const socialLinks = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/compaire",
    path: "M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.36V9h3.41v1.56h.05c.47-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0z",
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/compaire",
    path: "M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16zM12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63a5.86 5.86 0 0 0-2.13 1.38A5.86 5.86 0 0 0 .63 4.14C.33 4.9.13 5.78.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.32.79.74 1.46 1.38 2.13a5.86 5.86 0 0 0 2.13 1.38c.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56a5.86 5.86 0 0 0 2.13-1.38 5.86 5.86 0 0 0 1.38-2.13c.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91a5.86 5.86 0 0 0-1.38-2.13A5.86 5.86 0 0 0 19.86.63C19.1.33 18.22.13 16.95.07 15.67.01 15.26 0 12 0zm0 5.84a6.16 6.16 0 1 0 0 12.32 6.16 6.16 0 0 0 0-12.32zm0 10.16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.41-11.85a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88z",
  },
  {
    label: "X (formerly Twitter)",
    href: "https://x.com/compaire",
    path: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z",
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/@compaire",
    path: "M23.5 6.2a3 3 0 0 0-2.1-2.13C19.55 3.6 12 3.6 12 3.6s-7.55 0-9.4.47A3 3 0 0 0 .5 6.2C0 8.06 0 12 0 12s0 3.94.5 5.8a3 3 0 0 0 2.1 2.13c1.85.47 9.4.47 9.4.47s7.55 0 9.4-.47a3 3 0 0 0 2.1-2.13C24 15.94 24 12 24 12s0-3.94-.5-5.8zM9.6 15.6V8.4l6.27 3.6-6.27 3.6z",
  },
];

const renderLink = (link: FooterLink) => {
  const isExternal =
    link.external || link.href.startsWith("mailto:") || link.href.startsWith("http");

  if (isExternal || link.href === "#") {
    return (
      <a href={link.href} className="footer-link">
        {link.label}
      </a>
    );
  }

  return (
    <Link to={link.href} className="footer-link">
      {link.label}
    </Link>
  );
};

const LinkColumn = ({
  headingId,
  heading,
  links,
}: {
  headingId: string;
  heading: string;
  links: FooterLink[];
}) => (
  <nav aria-labelledby={headingId}>
    <h4 id={headingId} className="footer-col-title">
      {heading}
    </h4>
    <ul className="footer-links">
      {links.map((link) => (
        <li key={link.label}>{renderLink(link)}</li>
      ))}
    </ul>
  </nav>
);

/**
 * "marketing" renders the v3.3 marketing-site footer used by the public
 * marketing and legal routes; "legacy" (the default) keeps this footer for its
 * other callers, the public organization profile and news pages.
 */
const LandingFooter = ({ appearance = "legacy" }: { appearance?: "legacy" | "marketing" }) => {
  if (appearance === "marketing") return <MarketingFooter />;
  return (
    <footer role="contentinfo" className="landing-footer">
      <div className="landing-footer-inner">
        <div className="footer-top">
          {/* Column 1 — Brand */}
          <div className="footer-brand">
            <Link to="/" aria-label="Compaire home" className="footer-lockup">
              <CompaireLockup />
            </Link>
            <p className="footer-tagline">Career Intelligence for Real Estate.</p>
            <div className="footer-socials" aria-label="Compaire on social media">
              {socialLinks.map(({ label, href, path }) => (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social"
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d={path} />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* Column 2 — Product */}
          <LinkColumn headingId="footer-product" heading="Product" links={productLinks} />

          {/* Column 3 — Company */}
          <LinkColumn headingId="footer-company" heading="Company" links={companyLinks} />

          {/* Column 4 — Legal & Trust */}
          <LinkColumn headingId="footer-legal" heading="Legal & Trust" links={legalLinks} />
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">© 2026 Compaire. All rights reserved.</p>
          <p className="footer-built-for">
            Built for the next generation of real estate professionals.
          </p>
        </div>
      </div>

      <style>{`
        .landing-footer {
          background: hsl(var(--card));
          border-top: 1px solid hsl(var(--border));
          padding: 56px 0 40px;
        }
        .landing-footer-inner {
          max-width: 1180px;
          margin: 0 auto;
          padding: 0 24px;
        }
        .footer-top {
          display: grid;
          grid-template-columns: 210px 1fr 1fr 1fr;
          gap: 48px;
          margin-bottom: 44px;
        }
        .footer-brand { display: flex; flex-direction: column; }
        .footer-lockup {
          display: inline-block;
          text-decoration: none;
          line-height: 0;
        }
        .footer-lockup svg {
          height: 22px;
          width: auto;
          display: block;
        }
        .footer-tagline {
          font-family: 'Inter', sans-serif;
          font-size: 12.5px;
          line-height: 1.6;
          color: hsl(var(--ink-500));
          max-width: 170px;
          margin: 14px 0 0;
        }
        .footer-socials {
          margin-top: 22px;
          display: flex;
          align-items: center;
          gap: 14px;
        }
        .footer-social {
          display: inline-flex;
          width: 17px;
          height: 17px;
          color: hsl(var(--ink-500));
          transition: color 0.15s ease;
        }
        .footer-social:hover { color: hsl(var(--ink-900)); }
        .footer-social svg {
          width: 17px;
          height: 17px;
          display: block;
          fill: currentColor;
        }
        .footer-col-title {
          font-family: 'DM Mono', ui-monospace, monospace;
          font-size: 10px;
          font-weight: 500;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: hsl(var(--ink-500));
          margin: 0 0 14px;
        }
        .footer-links {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 9px;
        }
        .footer-link {
          font-family: 'Inter', sans-serif;
          font-size: 13.5px;
          color: hsl(var(--ink-700));
          text-decoration: none;
          transition: color 0.15s ease;
          line-height: 1.4;
          display: inline-block;
        }
        .footer-link:hover { color: hsl(var(--ink-900)); }
        .footer-bottom {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 24px;
          padding-top: 24px;
          border-top: 1px solid hsl(var(--border));
        }
        .footer-copyright {
          font-family: 'DM Mono', ui-monospace, monospace;
          font-size: 10px;
          color: hsl(var(--ink-500));
          letter-spacing: 0.03em;
          margin: 0;
        }
        .footer-built-for {
          font-family: 'Newsreader', Georgia, serif;
          font-style: italic;
          font-size: 13px;
          color: hsl(var(--ink-500));
          margin: 0;
        }
        @media (max-width: 860px) {
          .footer-top {
            grid-template-columns: 1fr 1fr;
            gap: 32px;
          }
          .footer-brand { grid-column: 1 / -1; }
          .footer-bottom {
            flex-direction: column;
            align-items: flex-start;
            gap: 16px;
          }
        }
      `}</style>
    </footer>
  );
};

export default LandingFooter;
